var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerSolid(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-dot-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8062 19.2952C13.5513 17.1113 17.5313 11.8183 17.5313 8.84521C17.5313 5.23942 14.6058 2.31396 11 2.31396C7.39421 2.31396 4.46875 5.23942 4.46875 8.84521C4.46875 11.8183 8.44873 17.1113 10.1938 19.2952C10.6122 19.8157 11.3878 19.8157 11.8062 19.2952ZM11 6.66813C11.5774 6.66813 12.1311 6.8975 12.5394 7.30578C12.9477 7.71407 13.1771 8.26782 13.1771 8.84521C13.1771 9.42261 12.9477 9.97636 12.5394 10.3846C12.1311 10.7929 11.5774 11.0223 11 11.0223C10.4226 11.0223 9.86885 10.7929 9.46057 10.3846C9.05229 9.97636 8.82292 9.42261 8.82292 8.84521C8.82292 8.26782 9.05229 7.71407 9.46057 7.30578C9.86885 6.8975 10.4226 6.66813 11 6.66813Z",
    fill: "#086EC5"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSolid);
export default __webpack_public_path__ + "static/media/marker-solid.28a451e88f127a545233645d1580cf81.svg";
export { ForwardRef as ReactComponent };